{
	"banner": {
		"acceptAll": "Принять все",
		"customise": "Настроить",
		"policy": "Политика cookie",
		"rejectAll": "Только необходимые",
		"save": "Сохранить",
		"text": "Cookie помогают нам улучшать IEC и подбирать контент под вас.",
		"title": "IEC — под вас"
	},
	"categories": {
		"advertising": {
			"hint": "Улучшение алгоритмов персонализации контента, в том числе рекламного.",
			"label": "Персонализация"
		},
		"analytics": {
			"hint": "Помогает понять, что работает, а что стоит улучшить.",
			"label": "Улучшение сервисов"
		},
		"necessary": {
			"hint": "Вход, безопасность и ваши настройки. Всегда включены.",
			"label": "Необходимые"
		}
	},
	"error": "Не удалось сохранить выбор. Попробуйте ещё раз.",
	"offer": {
		"allow": "Разрешить",
		"decline": "Не сейчас",
		"text": "Разрешите подбирать контент под вас, в том числе рекламный.",
		"title": "Контент, подобранный для вас"
	},
	"att": {
		"continue": "Продолжить",
		"text": "Разрешите персонализацию — и мы подберём контент под вас, в том числе рекламный. Следом спросит iOS."
	}
}
